import { getLogger } from "@expert/logging";
import type { AnalyticsEventModel, ExtendedEventData } from "@soluto-private/eventualize";
import { getSharedApiClient } from "@/shared-utils";

const logger = getLogger({ module: "Analytics" });

async function analyticsApiSink(eventModel: AnalyticsEventModel<ExtendedEventData>) {
    try {
        await getSharedApiClient().extend({ retry: 3 }).post("api/analytics/v1/dispatch", { json: eventModel });
        return true;
    } catch (error: unknown) {
        logger.error({ error }, "Unable to send analytics events after multiple tries");
        return false;
    }
}

export default analyticsApiSink;
